export default __webpack_public_path__ + "static/char-s-36-zh-Hant-e2b6a06332a86e965dd6373f1deed666.webp";